// *********************************
// CoolGames Builder JavaScript file
// *********************************
import { ComponentButton } from "../../framework/components/ComponentButton";
import { ComponentLabel } from "../../framework/components/ComponentLabel";
import { ComponentSpine } from "../../framework/components/ComponentSpine";
import { DialogBase } from "../../framework/dialogs/DialogBase";
import { tgfDictionary } from "../../framework/tgfDictionary";
import { tgfDialogs } from "../../framework/dialogs/tgfDialogs";
import { tgfGraphics } from "../../framework/tgfGraphics";
import { tgfSettings } from "../../framework/tgfSettings";
import { angrybirds_regular } from "../AssetDefinitions/FontDefinitions";
import { s_black_square } from "../AssetDefinitions/ImageDefinitions";
import { s_time_loader } from "../AssetDefinitions/SpineDefinitions";
tgfSettings.dialogDefaults.loadingOverlay = {
    onReconnect: null,
    text: "LOADING_VIDEO_TEXT",
    onError: null,
    components: [],
    autoCloseDelay: -1
};
export var LoadingOverlay = function (properties) {
    "use strict";
    this.name = "LoadingOverlay"; // The name of the dialog
    this.disableInput = false; // If enabled blocks input on buttons
    // Initialize properties
    this.initialize(tgfSettings.dialogDefaults.loadingOverlay);
    // Set user properties
    if (properties !== undefined) {
        this.setProperties(properties);
    }
};
// Inherit the base dialog
tgfDialogs.inherit(LoadingOverlay, DialogBase);
LoadingOverlay.prototype.doPrepare = function () {
    "use strict";
    var self = this;
    var i;
    var font = {
        fontFace: angrybirds_regular.fontFace,
        fontSize: 46,
        fillColor: "#fefefe",
        align: "center",
        baseline: "middle",
        shadow: { active: true, color: 'rgba(50, 49, 65, 0.7)', offsetX: 2, offsetY: 3, blur: 1, distance: 4 }
    };
    // Background is a button to block input
    this.transparentBlack = new ComponentButton({
        x: -100,
        y: -100,
        xScale: Math.round(tgfGraphics.areaWidth / s_black_square.width) + 20,
        yScale: Math.round(tgfGraphics.areaHeight / s_black_square.height) + 20,
        alpha: 0.5,
        image: s_black_square
    });
    this.addComponent(this.transparentBlack);
    this.loaderImage = new ComponentSpine({
        spineAnimation: s_time_loader,
        animationClip: "loading_hourglass",
        repeat: true
    });
    this.addComponent(this.loaderImage);
    this.textComponent = new ComponentLabel({
        y: 125,
        text: tgfDictionary.getText(this.text),
        font: font
    });
    this.addComponent(this.textComponent);
    if (this.autoCloseDelay >= 0) {
        this.timeToClose = this.autoCloseDelay;
    }
};
LoadingOverlay.prototype.handleEndStep = function (timePassed) {
    "use strict";
    LoadingOverlay.uber.handleEndStep.call(this);
    if (this.timeToClose > 0) {
        this.timeToClose -= timePassed;
        if (this.timeToClose <= 0) {
            this.hide();
            this.free();
            if (this.onError) {
                this.onError();
            }
        }
    }
};
